import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { auditApi } from "@/api/client";
import { EmptyState } from "@/components/EmptyState";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-GB") : "");

export default function AuditPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    auditApi.list({ limit: 200 }).then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-3xl px-4 py-5 md:py-8">
      <button onClick={() => navigate("/more")} className="mb-3 inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-slate-800">
        <ArrowLeft className="h-4 w-4" /> More
      </button>
      <h1 className="mb-4 font-heading text-xl font-extrabold tracking-tight text-slate-900 md:text-2xl">Audit trail</h1>
      {loading ? (
        <div className="p-6 text-sm text-slate-400">Loading…</div>
      ) : items.length === 0 ? (
        <EmptyState testid="audit-empty" icon={ShieldCheck} title="No audit events yet" description="Mutations across the tenant will appear here." />
      ) : (
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-testid="audit-list">
          {items.map((e) => (
            <div key={e.id} data-testid={`audit-row-${e.id}`} className="border-b border-slate-100 p-3.5 text-sm last:border-0">
              <div className="flex items-center justify-between gap-2">
                <span className="font-mono text-xs font-semibold text-teal-700">{e.action}</span>
                <span className="text-xs text-slate-400">{fmt(e.created_at)}</span>
              </div>
              <p className="mt-0.5 text-xs text-slate-500">
                {e.entity_type}{e.entity_id ? ` · ${e.entity_id}` : ""}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
